import { createContext, useEffect, useState } from 'react';

const initialValues = {
	title: '',
	version: '',
	pi: '',
	deparment: '',
	sponsor: '',
	fundingType: '',
	phaseOfStudy: [],
	nationalClinicalTrial: '',
	informedConsentFormDate: '',
	irbApprobalDate: '',
	clinicalTrialAgreementDate: '',
	clinicalTrialAgreementExecutionDate: '',
	clinicalTrialAgreementVersion: '',
	crfoBudgetReviewCompletedDate: '',
	nameOfInvestigationalDrug: '',
	nameOfInvestigationalDevice: '',
	IND: '',
	IDE: '',
	longTitle: '',
	protocolDate: ''
};

const initalValuesFromStudyData = (study) =>
	study
		? {
				title: study.title,
				version: '',
				pi: '',
				deparment: study.department,
				sponsor: study.sponsor,
				fundingType: study.fundingType,
				phaseOfStudy: [],
				nationalClinicalTrial: '',
				informedConsentFormDate: '',
				irbApprobalDate: '',
				clinicalTrialAgreementVersion: '',
				crfoBudgetReviewCompletedDate: '',
				nameOfInvestigationalDrug: '',
				nameOfInvestigationalDevice: '',
				IND: '',
				IDE: '',
				longTitle: study.longTitle,
				protocolDate: ''
			}
		: undefined;

const EditStudyContext = createContext(initialValues);

export const EditStudyContextProvider = (props) => {
	const serverInitialValues = initalValuesFromStudyData(
		props.initialState
	);

	const [formValues, setFormValues] = useState(
		serverInitialValues || initialValues
	);

	useEffect(() => {
		if (
			serverInitialValues &&
			JSON.stringify(serverInitialValues) !==
				JSON.stringify(formValues)
		) {
			setFormValues(serverInitialValues);
		}
	}, [serverInitialValues]);

	const updateFormValues = (formValues) => {
		setFormValues(formValues);
	};

	const contextValue = {
		formValues,
		updateFormValues
	};

	return (
		<EditStudyContext.Provider value={contextValue}>
			{props.children}
		</EditStudyContext.Provider>
	);
};

export default EditStudyContext;
